import { createEffect } from "effector";
import { AppError } from "../../services/classes";
import { LaundryActivation, LaundryMachineOption, LaundryTypeOption, Receipt } from "../../types/laundry.types";
import { activateLaundryMachine, getLaundryMachinesByStation, getLaundryTypesByStation, sendReceipt } from "../../services/laundryService";
import { getStationByCode, getStations } from "../../services/stationsService";

export const fetchLaundryTypesEffect = createEffect<string, LaundryTypeOption[], AppError>(async (code: string) => {
  const response = await getStationByCode(code);
  return await getLaundryTypesByStation(response.id);
});

export const fetchLaundryMachinesEffect = createEffect<{ code: string; type: string }, LaundryMachineOption[], AppError>(async ({ code, type }) => {
  return await getLaundryMachinesByStation(code, type);
});

export const sendReceiptEffect = createEffect<Receipt, void, AppError>(async (receipt: Receipt) => {
  const response = await sendReceipt(receipt);
  return response;
});

export const activateLaundryMachineEffect = createEffect<LaundryActivation, void, Error>(async (payload: LaundryActivation) => {
  await activateLaundryMachine(payload);
});
